module.exports = __webpack_public_path__ + "img/icon-selected.751a2972.svg";